module.exports = __webpack_public_path__ + "img/10.a6dbc73c.jpg";